export default "__VITE_ASSET__69952d77__"